/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */

import { loadState } from '../sessionStore';


export const getHeaders = () => {
  const { apiToken } = loadState();
  const header = {
    'Content-Type': 'application/json',
    'sec-fetch-site': 'cross-site',
    Accept: 'application/json',
  };
  if (apiToken !== undefined) {
    header.Authorization = `Bearer ${apiToken}`;
  }
  return header;
};

export const getAuth = () => {
  const { apiToken } = loadState();
  return { Authorization: `Bearer ${apiToken}` };
};

// eslint-disable-next-line max-len
export const getRootEntryPoint = () => process.env.REACT_APP_BACKEND_URL + process.env.REACT_APP_API_ENDPOINT;

const handleResponse = (response) => {
  if (!response.ok) {
    return Promise.reject(response);
  }
  return response.json();
};

const handleError = async (response) => {
  if (response.code === DOMException.ABORT_ERR) {
    return Promise.reject();
  }
  const error = await response.json().then((data) => data);
  return Promise.reject(error);
};

export const httpGet = (api, entryPoint = process.env.REACT_APP_API_ENDPOINT, signal = undefined) => {
  const server = process.env.REACT_APP_BACKEND_URL + entryPoint;
  const headers = getHeaders();
  return fetch(server + api, {
    method: 'GET',
    headers,
    signal,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const httpGetFile = (api, filename, entryPoint = process.env.REACT_APP_API_ENDPOINT) => {
  const server = process.env.REACT_APP_BACKEND_URL + entryPoint;
  const headers = getHeaders();

  return fetch(server + api, {
    method: 'GET',
    headers,
  }).then((response) => response.body)
    .then((body) => {
      const reader = body.getReader();
      return new ReadableStream({
        start(controller) {
          const pump = () => reader.read().then(({ done, value }) => {
            // When no more data needs to be consumed, close the stream
            if (done) {
              controller.close();
              return;
            }
            // Enqueue the next data chunk into our target stream
            controller.enqueue(value);
            // eslint-disable-next-line consistent-return
            return pump();
          });
          return pump();
        },
      });
    }).then((stream) => new Response(stream))
    .then((response) => response.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    });
};


export const httpPost = (api, data, entryPoint = process.env.REACT_APP_API_ENDPOINT) => {
  const server = process.env.REACT_APP_BACKEND_URL + entryPoint;
  const headers = getHeaders();
  return fetch(server + api, {
    method: 'POST',
    body: JSON.stringify(data),
    headers,
  })
    .then(handleResponse)
    .catch(handleError);
};
export const httpPostGetFile= (api, data,filename, entryPoint = process.env.REACT_APP_API_ENDPOINT) => {
  const server = process.env.REACT_APP_BACKEND_URL + entryPoint;
  const headers = getHeaders();
  return fetch(server + api, {
    method: 'POST',
    body: JSON.stringify(data),
    headers,
  }).then((response) => response.body)
  .then((body) => {
    const reader = body.getReader();
    return new ReadableStream({
      start(controller) {
        const pump = () => reader.read().then(({ done, value }) => {
          // When no more data needs to be consumed, close the stream
          if (done) {
            controller.close();
            return;
          }
          // Enqueue the next data chunk into our target stream
          controller.enqueue(value);
          // eslint-disable-next-line consistent-return
          return pump();
        });
        return pump();
      },
    });
  }).then((stream) => new Response(stream))
  .then((response) => response.blob())
  .then((blob) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  });
};


export const httpPut = (api, data, entryPoint = process.env.REACT_APP_API_ENDPOINT) => {
  const server = process.env.REACT_APP_BACKEND_URL + entryPoint;
  const headers = getHeaders();
  return fetch(server + api, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const httpDelete = (api, entryPoint = process.env.REACT_APP_API_ENDPOINT) => {
  const server = process.env.REACT_APP_BACKEND_URL + entryPoint;
  const headers = getHeaders();
  return fetch(server + api, {
    method: 'DELETE',
    headers,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const httpGetPlain = (url, signal = undefined) => {
  
  const headers = getHeaders();
  return fetch(url, {
    method: 'GET',
    headers,
    signal,
  })
    .then(handleResponse)
    .catch(handleError);
};